import { useTranslation } from "react-i18next";

export const Logo = ({ size = "md", showSlogan = false, className = "" }) => {
  const { t } = useTranslation();
  const sizes = {
    sm: { wing: 18, as: "text-2xl", tr: "text-sm" },
    md: { wing: 24, as: "text-3xl", tr: "text-base" },
    lg: { wing: 36, as: "text-5xl", tr: "text-xl" },
    xl: { wing: 48, as: "text-7xl", tr: "text-2xl" },
  };
  const s = sizes[size];
  return (
    <div className={`inline-flex flex-col items-center ${className}`} data-testid="as-logo">
      <div className="flex items-center gap-1">
        <Wing size={s.wing} mirror />
        <div className="flex flex-col items-center leading-none">
          <span className={`as-heading ${s.as} text-white`}>
            <span className="text-as-green">A</span>S
          </span>
          <span className={`as-heading ${s.tr} text-white tracking-[0.3em] mt-1`}>TRAINING</span>
        </div>
        <Wing size={s.wing} />
      </div>
      {showSlogan && (
        <div className="mt-3 text-center">
          <p className="as-label text-[10px] text-as-green">
            {t("footer.tagline")}
          </p>
        </div>
      )}
    </div>
  );
};

const Wing = ({ size = 24, mirror = false }) => (
  <svg
    width={size}
    height={size * 0.7}
    viewBox="0 0 60 42"
    style={{ transform: mirror ? "scaleX(-1)" : "none" }}
    aria-hidden="true"
  >
    <path
      d="M2 28 L20 6 L26 14 L30 8 L36 18 L44 10 L50 22 L58 16 L52 36 L40 32 L34 38 L26 32 L18 36 L10 34 Z"
      fill="#39FF14"
      opacity="0.9"
    />
    <path
      d="M14 22 L26 14 L30 8 L36 18 L44 10 L46 24 L36 26 L30 30 L22 28 Z"
      fill="#FFFFFF"
      opacity="0.85"
    />
  </svg>
);
